import { storeService } from '../data/storeService';

/**
 * Attach stores to a user object for auth context hydration.
 * @param {object|null} user
 * @param {Array} stores
 * @returns {object|null}
 */
export const withStores = (user, stores = []) => {
  if (!user) return null;
  return { ...user, stores: Array.isArray(stores) ? stores : [] };
};

/**
 * Resolve the user's stores from the user payload or by fetching from the API.
 * Prefers a non-empty user.stores; otherwise fetches GET /api/v1/stores.
 * Does not coerce fetch failures to an empty list — callers must handle errors.
 * @param {object|null} user
 * @returns {Promise<Array>}
 */
export const resolveUserStores = async (user) => {
  const nestedStores = user?.stores;
  if (Array.isArray(nestedStores) && nestedStores.length > 0) {
    return nestedStores;
  }

  const stores = await storeService.getStores();
  return Array.isArray(stores) ? stores : [];
};

/**
 * Navigate based on how many stores the user has access to.
 * @param {Function} navigate - react-router navigate
 * @param {Array} stores
 */
export const navigateForStores = (navigate, stores = []) => {
  const list = Array.isArray(stores) ? stores : [];

  if (list.length === 0) {
    navigate('/no-stores');
  } else if (list.length === 1) {
    navigate(`/store/${list[0].customer_id}?market=${list[0].market}`);
  } else {
    navigate('/stores');
  }
};

/**
 * Paths where post-auth routing should run (including sticky /no-stores recovery).
 */
export const shouldRedirectForStores = (pathname) =>
  pathname === '/' || pathname === '/login' || pathname === '/no-stores';
